import type { Element, Properties, Root } from 'hast';
import { merge } from 'lodash';
import { visit } from 'unist-util-visit';

// Store properties by node ID to restore later.
const propertiesMap = new Map<string, Properties>();

/**
 * A rehype plugin that runs before rehype-raw to store node properties.
 */
export function rehypeStoreProperties() {
  return (tree: Root) => {
    // Clear the maps for each new document.
    propertiesMap.clear();

    // Store properties of all elements
    visit(tree, 'element', (node: Element) => {
      if (node.properties) {
        const nodeId = node.properties.id;

        if (typeof nodeId === 'string') {
          propertiesMap.set(nodeId, { ...node.properties });
        }
      }
    });
  };
}

/**
 * A rehype plugin that runs after rehype-raw to restore node properties that are set during remark cycle.
 */
export function rehypeRestoreProperties() {
  return (tree: Root) => {
    // Restore properties to elements
    visit(tree, 'element', (node: Element) => {
      if (node.properties) {
        const nodeId = node.properties.id;

        // If we have a node ID and stored properties, restore them.
        if (typeof nodeId === 'string' && propertiesMap.has(nodeId)) {
          const storedProps = propertiesMap.get(nodeId);
          if (storedProps) {
            const dataProps = Object.entries(storedProps).reduce<Properties>(
              (acc, [key, value]) => {
                acc[key] = value;
                return acc;
              },
              {}
            );

            // Restore properties from remark cycle.
            node.properties = merge({}, node.properties, dataProps);
          }
        }
      }
    });
  };
}
